import ROUTE_NAMES from '../../router/names';
import decorate from './decorate';

export default (schoolManagePermission, teamManagePermission, playerManagePermission, playerMiddlePermission, notice) => {
    return decorate([
        {
            title: '个人信息',
            icon: '&#xe60a;',
            active: true,
            children: [
                {
                    title: '信息编辑',
                    route_name: ROUTE_NAMES.PERSONAL.INFORMATION
                },
                {
                    title: '站内通知',
                    route_name: ROUTE_NAMES.PERSONAL.INTERNAL_MESSAGE_UNREAD,
                    related_route_names: [
                        ROUTE_NAMES.PERSONAL.INTERNAL_MESSAGE_UNREAD,
                        ROUTE_NAMES.PERSONAL.INTERNAL_MESSAGE_READ
                    ],
                    notice: notice === true
                }
            ]
        },
        {
            title: '我要参赛',
            icon: '&#xe611;',
            active: true,
            children: [
                // {
                //     title: '参赛须知',
                //     route_name: ''
                // },
                {
                    title: '加入队伍',
                    route_name: ROUTE_NAMES.PLAYER.ENTRY
                },
                {
                    title: '入队审批',
                    route_name: ROUTE_NAMES.PLAYER.CONTESTANT_APPLICATION_UNFINISHED,
                    related_route_names: [
                        ROUTE_NAMES.PLAYER.CONTESTANT_APPLICATION_FINISHED,
                        ROUTE_NAMES.PLAYER.CONTESTANT_APPLICATION_UNFINISHED
                    ],
                    permission: playerManagePermission
                },
                {
                    title: '成员管理',
                    route_name: ROUTE_NAMES.PLAYER.MEMBER,
                    permission: playerManagePermission
                },
                {
                    title: '指定成员身份',
                    route_name: ROUTE_NAMES.PLAYER.ROLE,
                    permission: playerManagePermission
                },
                {
                    title: '资料上传',
                    route_name: ROUTE_NAMES.PLAYER.MIDDLE_CHECK,
                    permission: playerMiddlePermission
                },
                {
                    title: '信息填报',
                    route_name: ROUTE_NAMES.PLAYER.INFORMATION_RECOMMENDATION,
                    related_route_names: [
                        ROUTE_NAMES.PLAYER.INFORMATION_RECOMMENDATION,
                        ROUTE_NAMES.PLAYER.INFORMATION_INTRODUCE,
                        ROUTE_NAMES.PLAYER.INFORMATION_ROBOT,
                        ROUTE_NAMES.PLAYER.INFORMATION_SPONSORSHIP,
                        ROUTE_NAMES.PLAYER.INFORMATION_CONSIGNEE,
                        ROUTE_NAMES.PLAYER.INFORMATION_PRESENT,
                        ROUTE_NAMES.PLAYER.INFORMATION_ACCOMMODATION,
                        ROUTE_NAMES.PLAYER.INFORMATION_GROUP_PHOTO,
                        ROUTE_NAMES.PLAYER.INFORMATION_SPECIAL_COMPETITION
                    ],
                    permission: playerManagePermission
                },
                {
                    title: '参赛确认',
                    route_name: ROUTE_NAMES.PLAYER.CONFIRM_OVERVIEW,
                    related_route_names: [
                        ROUTE_NAMES.PLAYER.CONFIRM_OVERVIEW,
                        ROUTE_NAMES.PLAYER.CONFIRM_DETAIL,
                        ROUTE_NAMES.PLAYER.CONFIRM_CONFIRM
                    ],
                    permission: playerManagePermission
                }
            ]
        },
        {
            title: '学校管理',
            icon: '&#xe607;',
            active: true,
            children: [
                {
                    title: '基本信息',
                    route_name: ROUTE_NAMES.MANAGER.SCHOOL_INFORMATION,
                    permission: schoolManagePermission
                },
                {
                    title: '指定队伍管理者',
                    route_name: ROUTE_NAMES.MANAGER.SCHOOL_TEAM_MANAGER,
                    permission: schoolManagePermission
                }
            ]
        },
        {
            title: '队伍管理',
            icon: '&#xe608;',
            active: true,
            children: [
                {
                    title: '基本信息',
                    route_name: ROUTE_NAMES.MANAGER.TEAM_INFORMATION,
                    permission: teamManagePermission
                },
                {
                    title: '成果管理',
                    route_name: ROUTE_NAMES.MANAGER.TEAM_ACHIEVEMENT,
                    permission: teamManagePermission
                },
                {
                    title: '参赛申请',
                    route_name: ROUTE_NAMES.MANAGER.TEAM_PLAYER_APPLICATION,
                    permission: teamManagePermission
                }
            ]
        },
        {
            title: '历届回顾',
            icon: '&#xe62d;',
            active: true,
            children: [
                {
                    title: '我的参赛',
                    route_name: ROUTE_NAMES.HISTORY.PLAYER
                },
                {
                    title: '我的荣誉',
                    route_name: ROUTE_NAMES.HISTORY.AWARD
                }
            ]
        }
    ]);
};
